import { useCallback, useState } from 'react';
// import { PATHS } from '@bo-constants/routes';
import { playerPacks } from '@bo-test/mock/data/playerPacks';
import { useLeagues } from '@bo-hooks/useLeagues';
// import { useNavigate } from 'react-router-dom';

export const usePlayerPacksTable = () => {
  // const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState<number>(1);

  // const handleClickPlayerPack = useCallback(
  //   ({ playerPackId }: { playerPackId: string }) => {
  //     navigate(`${PATHS.PLAYER_PACKS}/${playerPackId}`);
  //   },
  //   [navigate]
  // );

  const { leaguesList } = useLeagues();

  const handleCurrentPageChange = useCallback(() => {
    setCurrentPage((prevPage) => prevPage + 1);
  }, []);

  const handleResetCurrentPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  return {
    currentPage,
    leaguesList,
    onPageChange: handleCurrentPageChange,
    onResetPageChange: handleResetCurrentPage,
    playerPacks,
    totalPages: 1
  };
};
